// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-bar__reset-button[data-v-718ba53b]{display:flex;align-items:center}.filter-bar__reset-button span[data-v-718ba53b]{display:flex}.filter-bar__reset-button__text[data-v-718ba53b]{font-weight:700;margin-inline-start:4px}@media(max-width:480px){.filter-bar__reset-button__text[data-v-718ba53b]{display:none!important}}", ""]);
// Exports
module.exports = exports;
